import type {
  AdminSchedulingCatalogFocus,
  AdminSchedulingView,
} from "./scheduling-portal-model";

type CurrentSchedulingDestination =
  | { readonly kind: "workspace"; readonly value: AdminSchedulingView }
  | {
      readonly kind: "catalog";
      readonly value: AdminSchedulingCatalogFocus;
    };

export interface AdminSchedulingNavigationProps {
  readonly current: CurrentSchedulingDestination;
}

const destinations = [
  { kind: "workspace", value: "day", label: "Day", href: "/admin/calendar" },
  {
    kind: "workspace",
    value: "week",
    label: "Week",
    href: "/admin/calendar/week",
  },
  {
    kind: "workspace",
    value: "resource-lanes",
    label: "Resource lanes",
    href: "/admin/scheduler",
  },
  {
    kind: "workspace",
    value: "list",
    label: "Appointment list",
    href: "/admin/appointments",
  },
  {
    kind: "workspace",
    value: "kanban",
    label: "Status board",
    href: "/admin/appointments/kanban",
  },
  {
    kind: "catalog",
    value: "all",
    label: "Resource catalog",
    href: "/admin/resources",
  },
] as const;

export function AdminSchedulingNavigation({
  current,
}: AdminSchedulingNavigationProps) {
  return (
    <nav className="scheduling-view-navigation" aria-label="Scheduling views">
      <ul>
        {destinations.map((destination) => (
          <li key={`${destination.kind}-${destination.value}`}>
            <a
              href={destination.href}
              aria-current={
                destination.kind === current.kind &&
                destination.value === current.value
                  ? "page"
                  : undefined
              }
            >
              {destination.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
